module.exports = __webpack_public_path__ + "static/media/iternal_empty_box.7af694e5.svg";